<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section-oh form-section ">
              <p class="form-title text-center" style="font-size: 15px;">
                Isaac Peck <br />
                6353 El Cajon Blvd, Suite 124-605<br/>
                San Diego, CA 92115
              </p>
              <p class="form-title text-center" style="font-size: 20px;">
                NOTICE OF EXCESS LINE PLACEMENT
              </p>
              <p class="form-title text-center" style="font-size: 15px;">
                Date: {{ formattedCurrentDate() }}
              </p>




            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure">
                  
                    Consistent  with  the  requirements  of  the  New  York  Insurance  Law  and  Regulation  41
                    <strong>
                      {{ quote.fullLegalNameOfApplicant }}</strong>  is  hereby  advised  that  all  or  a  portion  of  the  required  coverages  have  been placed by Isaac Peck
                    with insurers not authorized to do an insurance business in New York and which are not subject to supervision by this State.
                    Placements with unauthorized insurers can only be made under one of the following circumstances:
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-left: 20px">
                  
                    a) A diligent effort was first made to place the required insurance with companies authorized in New
                    York to write coverages of the kind requested; or
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-left: 20px">
                  
                    b) NO diligent effort was required because i) the coverage qualifies as an “Export List” risk, or ii) the
                    insured qualifies as an “Exempt Commercial Purchaser.”
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    Policies issued by such unauthorized insurers may not be subject to all of the regulations of the
                    Superintendent of Financial Services pertaining to policy forms. In the event of insolvency of the
                    unauthorized insurers, losses will not be covered by any New York State security fund.
                  </p>

                <p class="mb-3 ar-sl-disclosure text-center" style="margin-top: 20px;margin-bottom: 50px">
                  
                    <strong>
                      TOTAL COST FORM (NON TAX ALLOCATED PREMIUM TRANSACTION)
                    </strong>
                  </p>

                <p class="mb-3 ar-sl-disclosure">
                  
                    In consideration of your placing my insurance as described in the policy referenced below, I agree to pay the
                    total cost below which includes all premiums, inspection charges (1) and a service fee that includes taxes,
                    stamping fees, and (if indicated) a fee (1) for compensation in addition to commissions received, and other
                    expenses (1) .
                  </p>
                  <p class="mb-3 ar-sl-disclosure" align="left"> I further understand and agree that all fees, inspection charges and other expenses denoted by (1) are fully
                    earned from the inception date of the policy and are non-refundable regardless of whether said policy is
                    cancelled. Any policy changes which generate additional premium are subject to additional tax and stamping
                    fee charges.</p>
                <div class="row">
                <div class="col-md-6">
                  <section class="mt-3" >
                    <p class="mb-3 ar-sl-disclosure" align="left"> Re: Policy No.: TBD</p>
                  </section>
                </div>
                  <div class="col-md-6">
                    <section class="mt-3" >
                      <p class="mb-3 ar-sl-disclosure" align="left"> Insurer: United National Insurance Company</p>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                    <p class="mb-3 ar-sl-disclosure" align="left"> Policy Premium</p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        <strong>
                          Insurer Imposed Charges:
                        </strong>
                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Policy Fees (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Inspection Fees (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Total Taxable Charges
                      </p>
                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure text-left" align="left"> <strong v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</strong>
                        <strong v-else >{{ coverages[quote.coverage].premium }}</strong></p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        <br/>
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        $
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        $__________________________
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        <strong v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</strong>
                        <strong v-else >{{ coverages[quote.coverage].premium }}</strong>
                      </p>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure" align="left">   <strong>
                        Service Fee Charges:</strong></p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Excess Line Tax (3.60%)

                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Stamping Fee
                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Broker Fee (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Inspection Fee (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" align="left">
                        Other Expenses (specify) (1)
                      </p>

                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure text-left" align="left"> <br /></p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        <strong v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberSurplusLineTax }}</strong>
                        <strong v-else >{{ coverages[quote.coverage].surplusLineTax }}</strong>
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        <strong v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberStampingFee }}</strong>
                        <strong v-else >{{ coverages[quote.coverage].stampingFee }}</strong>
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        $
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                      $
                    </p>

                      <p class="mb-3 ar-sl-disclosure text-left" align="left">
                        <strong v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberExtraFee }}</strong>
                        <strong v-else >{{ coverages[quote.coverage].extraFee }}</strong>
                      </p>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure">
                      </p>

                    </section>
                  </div>
                  <div class="col-md-8">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure">
                        Total Policy Cost : <strong v-if="quote.cyberCoverage" >${{ removeOrepFeeTotal(coverages[quote.coverage].cyberTotal) }}</strong>
                        <strong v-else >${{ removeOrepFeeTotal(coverages[quote.coverage].total) }}</strong>
                      </p>

                    </section>
                  </div>
                </div>
                <div class="row">

                  <div class="col-md-8">
                    <section class="notice-form mt-3">
                      <p class="notice-form-date" style="text-align: left">Signature of Insured:</p>
                      <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Your Name to Sign"
                        name="slDisclosureSignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="quote.slDisclosureSignature"
                      >
                      <span
                        v-show="errors.has('slDisclosureSignature')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                    </section>
                  </div>
                </div>
                <p class="mb-3 ar-sl-disclosure">
                  
                    (1) = Fully earned
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 20px">
                  
                    NYSID Form: NELP/2011
                  </p>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "home-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      coverages() {
        return this.$store.state.homeInspector.coverages;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {

      removeOrepFeeTotal(total)
      {
        var number = Number(total.replace(/[^0-9\.-]+/g,""));
        console.log(number);
        return number - 150;
      },

      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },


      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>


